export function formatPrice( amount: number, currency: string, language: string) {
    return new Intl.NumberFormat(language, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'symbol',
        minimumFractionDigits: 2,
    }).format(amount);
}
